import React from "react";
import "./styles.scss";

import Button from "../../../common/button";
import { useNavigate } from "react-router-dom";
import Card from "./cardView";

const AgingPlace = (props) => {
  const { title, description, button_text, sub_content } = props;
  const Navigate = useNavigate();
  return (
    <>
      <div className="aging-place-container">
        <h3 className="age-title">{title}</h3>
        <p
          className="aging-content"
          dangerouslySetInnerHTML={{ __html: description }}
        />

        <Card sub_content={sub_content} />
        <Button
          onClick={() => Navigate(`${process.env.REACT_APP_BASE}/risk-fall`)}
        >
          {button_text}
        </Button>
      </div>
    </>
  );
};

export default AgingPlace;
